<template>
  <section v-on:click="sectionClicked">
    <Header ref="header" :class="{scrolled: scrolled}"/>
    <div class="loadingFull" v-if="loading"></div>
    <div class="notFoundCnt" v-else-if="!detail">
      <div class="notFound">
        <img src="../assets/not-found.png">
        <h4>404</h4>
        <h2>Halaman tidak ditemukan</h2>
        <p>We can't find the page you looking for</p>
        <button v-on:click="this.$router.push('/')"
          class="btn secondary">Back To Home</button>
      </div>
    </div>
    <div class="newsDetailPage" v-else>
      <div class="previewInfo" :class="{scrolled: scrolled}" v-if="detail.status !== 'published'">
        <img src="../assets/private.png">
        This is preview content, not available for public viewer.
      </div>
      <div class="newsHeader" v-if="detail.thumb"
        :style="{'background-image': `url(${detail.thumbHd})`}"></div>
      <div class="cnt">
        <div class="supportCnt">
          <div class="supportInfo">
            <h2>{{detail.title}}</h2>
            <div class="timestampCnt">
              <div class="category" v-if="detail.parent">{{detail.parent.name}}</div>
              <div class="timestamp">{{detail.publishDate | moment('dddd, DD MMMM YYYY')}}</div>
              <div class="reading-time">
                <span class="reading-time__label"></span>
                <span class="reading-time__duration"></span>
                <span class="reading-time__word-count"></span>
              </div>
            </div>
            <div class="articleDetail" v-html="detail.content"></div>
            <div class="tags" v-if="detail.tags">
              <div class="tag" v-for="(tag, i) in detail.tags" :key="`tag${i}`">
                {{tag.trim()}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  name: 'home',
  components: { Header },
  data() {
    return {
      loading: true,
      scrolled: false,
      openDonationSelector: false,
      detail: null,
      related: [],
      products: [],
      donationsRlt: [],
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
      this.openDonationSelector = false;
    },
    docScrolled() {
      this.scrolled = (window.pageYOffset >= 30);
    },
  },
  created() { document.addEventListener('scroll', this.docScrolled); },
  destroyed() { document.removeEventListener('scroll', this.docScrolled); },
  mounted() {
    const { code } = this.$route.params;
    const { id } = this.$route.params;
    // eslint-disable-next-line
    const sign = this.$route.query._sign;
    const uri = (code) ? `article/${code}` : `article/detail/${id}?sign=${sign}`;
    this.$http.get(this.$config.uri(uri)).then((r) => {
      this.loading = false;
      if (r.data.status !== 200) {
        // Display error
        return;
      }
      this.detail = r.data.data;
      const rltUri = `article/all?parentId=${this.detail.parent.id}&related=${this.detail.id}&limit=3`;
      this.$http.get(this.$config.uri(rltUri)).then((rRlt) => {
        this.related = (rRlt.data.status === 200) ? rRlt.data.data : [];
      });
      this.$http.get(this.$config.uri('product/all?limit=4')).then((rPrd) => {
        this.products = (rPrd.data.status === 200) ? rPrd.data.data : [];
      });
      this.$http.get(this.$config.uri('donation/all?limit=3')).then((rDnt) => {
        this.donationsRlt = (rDnt.data.status === 200) ? rDnt.data.data : [];
      });
    });
  },
};
</script>

<style lang="scss">
.articleDetail{
  min-height: 60vh;
  p{
    margin: 0;
    font-size: 18px;
  }
  h3{
    font-size: 24px;
  }
  .theMedia{
    max-width: 100%;
    margin: 20px 0;
    border-radius: 5px;
  }
  ol, ul{
    padding-left: 30px;
    margin: 0;
    li{
      padding-left: 10px;
      font-size: 18px;
      margin-bottom: 14px;
      span{
        font-size: inherit !important;
      }
    }
  }
}
</style>

<style scoped lang="scss">
.newsDetailPage{
  margin-top: 96px;
}
.timestampCnt{
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  font-size: 15px;
  flex-wrap: wrap;
  color: #444;
  .category{
    background-color: #035fae;
    border-radius: 50px;
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    padding: 6px 14px;
    margin-right: 16px;
    white-space: nowrap;
    margin-bottom: 5px;
  }
  .timestamp{
    margin-bottom: 5px;
  }
}
.previewInfo{
  // background-color: yellow;
  // background-color: rgba(255, 255, 0, .86);
  background-image: linear-gradient(45deg, yellow, transparent);
  color: #000;
  padding: 10px 20px;
  position: fixed;
  top: 96px; left: 0;
  width: 100%;
  max-width: 960px;
  z-index: 9;
  transition: all .3s ease;
  display: flex;
  align-items: center;
  &.scrolled{
    top: 76px;
  }
  img{
    height: 20px;
    margin-top: -3px;
    margin-right: 10px;
  }
}
.newsHeader{
  height: 32vw;
  background-color: #ccc;
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;
  &.noImg{
    background-image: url(../assets/image-black.png);
    background-size: 64px auto;
    opacity: .36;
  }
}
.supportCnt{
  .supportInfo{
    box-sizing: border-box;
    padding: 40px 0;
    max-width: 860px;
    margin: 0 auto;
    @media (max-width: 960px) {
      padding-top: 20px;
    }
    @media (max-width: 680px) {
      padding-top: 10px;
    }
    h2{
      margin: 0 0 20px -1px;
      font-size: 48px;
      line-height: 1.3;
      @media (max-width: 960px) {
        font-size: 40px;
      }
      @media (max-width: 680px) {
        font-size: 30px;
      }
    }
    p{
      margin: 0 0 20px;
      font-size: 19px;
      line-height: 1.7;
    }
    .tags{
      display: flex;
      .tag{
        color: #035fae;
        font-weight: 600;
        font-size: 14px;
        margin-right: 10px;
      }
    }
  }
}
</style>
